/* eslint-disable */
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    singleAssignmentData: {},
    createAssignmentData: {},
    updateAssignmentDetailsData: {},
    addAssignmentFile: {},
    updateAssignmentFilesDetails: {},
    getAssignmentFilesDetailsData: {}
  },
  mutations: {
    createAssignmentMutation(state, value) {
      state.createAssignmentData = value
    },
    getSingleAssignment(state, value) {
      state.singleAssignmentData = value
    },
    updateSingleAssignment(state, value) {
      state.updateAssignmentDetailsData = value
    },
    assignmentFileMutation(state, value) {
      state.addAssignmentFile = value
    },
    updateAssignmentFilesData(state, value) {
      state.updateAssignmentFilesDetails = value
    },
    getAssignmentFilesDetails(state, value) {
      state.getAssignmentFilesDetailsData = value
    },
  },
  actions: {
    createAssignment(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/assignments/admin/assignment/', payload).then((res) => {
          context.commit('createAssignmentMutation', res.data);
          resolve(res);

        }).catch((err) => {
          console.log(err);
          reject(err);
        })
      });
    },
    getSignleAssignmentActn(context, payload) {
      let url = "/assignments/admin/assignment/" + payload.id + '/'
      return new Promise((resolve, reject) => {
        axios.get(url).then((res) => {
          context.commit('getSingleAssignment', res.data.data);
          resolve(res);

        }).catch((err) => {
          console.log(err);
          reject(err);
        })
      });
    },
    updateAssignmentDetailsByID(context, payload) {
      let url = baseURL + "/assignments/admin/assignment/";
      let id = payload.data.id;
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/', payload.data.data).then((res) => {
          context.commit('updateSingleAssignment', res.data.data);
          resolve(res);
        }).catch((err) => {
          console.log(err);
          reject(err);
        })
      });
    },
    removeAssignmentById(context, payload) {
      let url = baseURL + "/assignments/admin/assignment/";
      return new Promise((resolve, reject) => {
        axios.delete(url + payload.id + '/').then((response) => {
          resolve(response);
        }).catch((error) => {
          reject(error);
        })

      })
    },
    addAssignmentFileFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/assignments/admin/assignment/file/', payload, {
          headers: {
            'Content-Type': null
          }
        }).then((res) => {
          context.commit('assignmentFileMutation', res.data);
          resolve(res);
        }).catch((err) => {
          console.log(err);
          reject(err);
        })
      });
    },
    getAssignmentFileByIdFun(context, payload) {
      let url = "/assignments/admin/assignment/file/" + payload.id + '/'
      return new Promise((resolve, reject) => {
        axios.get(url).then((res) => {
          context.commit('getAssignmentFilesDetails', res.data.data);
          resolve(res);

        }).catch((err) => {
          console.log(err);
          reject(err);
        })
      });
    },
    removeAssignmentFileById(context, payload) {
      let url = baseURL + "/assignments/admin/assignment/file/";
      return new Promise((resolve, reject) => {
        axios.delete(url + payload.id + '/').then((response) => {
          resolve(response);
        }).catch((error) => {
          reject(error);
        })

      })
    },
    updateAssignmentFileByID(context, payload) {
      let url = baseURL + "/assignments/admin/assignment/file/";
      let id = payload.data.id;
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/', payload.data.formdata, {
          headers: {
            'Content-Type': null
          }
        }).then((res) => {
          context.commit('updateAssignmentFilesData', res.data.data);
          resolve(res);
        }).catch((err) => {
          reject(err);
        })
      });
    },

  },
  getters: {
    createAssignmentState: state => state.createAssignmentData,
    singleAssignmentState: state => state.singleAssignmentData,
    updateAssignmentDetailsDataState: state => state.updateAssignmentDetailsData,
    addAssignmentFileState: state => state.addAssignmentFile,
    updateAssignmentFilesDetailsState: state => state.updateAssignmentFilesDetails,
    getAssignmentFilesDetailsState: state => state.getAssignmentFilesDetailsData
  }
}